import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuItems = (props) => {
  const path = window.location.pathname;
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const consultationServices = [
    { name: "Software Development", path: "/consultation/software-development" },
    { name: "Security Consultation", path: "/consultation/security" },
    { name: "Software Maintenance", path: "/consultation/software-maintenance" },
    { name: "Digital Marketing", path: "/consultation/digital-marketing" },
    { name: "Digital Transformation", path: "/consultation/digital-transformation" },
    { name: "Technology Consultation", path: "/consultation/technology" },
  ];

  const isConsultationActive = consultationServices.some(service => path === service.path);
  const isAboutActive = path === "/about-us" || path === "/about/projects";

  return (
    <React.Fragment>
      <li className={path === "/" ? "current-menu-item" : ""}>
        <Link to="/">Home</Link>
      </li>
      <li 
        className={`menu-item-has-children ${isAboutActive ? "current-menu-item" : ""}`}
      >
        <Link to="/about-us">About</Link>
        <ul className="sub-menu">
          <li className={path === "/about-us" ? "current-menu-item" : ""}>
            <Link to="/about-us">About Us</Link>
          </li>
        </ul>
      </li>
      {/* <li className={path === "/services" ? "current-menu-item" : ""}>
        <Link to="/services">Services</Link>
      </li> */}
      <li 
        className={`menu-item-has-children ${isConsultationActive ? "current-menu-item" : ""}`}
        onMouseEnter={() => setIsConsultationOpen(true)}
        onMouseLeave={() => setIsConsultationOpen(false)}
      >
        <Link to="/consultation">Consultations</Link>
        <ul className={`sub-menu ${isConsultationOpen ? "show" : ""}`}>
          {consultationServices.map((service, index) => (
            <li key={index} className={path === service.path ? "current-menu-item" : ""}>
              <Link to={service.path}>{service.name}</Link>
            </li>
          ))}
        </ul>
      </li>
      <li className={path === "/contact-us" ? "current-menu-item" : ""}>
        <Link to="/contact-us">Contact Us</Link>
      </li>
    </React.Fragment>
  );
};

export default MenuItems;
